import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ColumnConfig } from '@core/models/skeleton.model';
import { SkeletonBlockComponent } from '../skeleton-block/skeleton-block.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'xemex-skeleton-table',
  imports: [MatTableModule, MatCheckboxModule, SkeletonBlockComponent, TranslateModule],
  standalone: true,
  templateUrl: './skeleton-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './skeleton-table.component.scss',
})
export class SkeletonTableComponent {
  columns = input<ColumnConfig[]>([]);
  totalNumberOfRows = input<number>(20);
  isSelection = input<boolean>(false);
  dataSource: any;
  columnDisplay: Array<string> = [];

  constructor() {}

  ngOnInit(): void {
    this.columnDisplay = this.columns().map(col => col.field);
    const data = new Array(this.totalNumberOfRows()).fill(0);
    this.dataSource = new MatTableDataSource(data);
  }
}
